import { useContext, useEffect } from 'react';

import { ThemeContext } from '@style/theme.provider';

import { ThemeEnum } from '@enum/style/theme.enum';

const ThemeMatchMedia = window.matchMedia('(prefers-color-scheme: dark)');

export const useThemeDetector = () => {
  const { theme, setTheme } = useContext(ThemeContext);

  const handleTheme = () => setTheme(ThemeMatchMedia.matches ? ThemeEnum.Dark : ThemeEnum.Light);

  useEffect(() => {
    handleTheme();
    ThemeMatchMedia.addEventListener('change', handleTheme);
    return () => ThemeMatchMedia.removeEventListener('change', handleTheme);
  }, []);

  return theme;
};
